import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { type UseFormReturn } from "react-hook-form";
import { type FormSchema } from "../onboarding-schema";
import { UserIcon } from "lucide-react";

interface NameStepProps {
  form: UseFormReturn<FormSchema>;
}

export function NameStep({ form }: NameStepProps) {
  return (
    <FormField
      control={form.control}
      name="full_name"
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel className="text-xl md:text-2xl font-semibold block bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
            What is your name?
          </FormLabel>
          <FormControl>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <UserIcon className="h-5 w-5 text-blue-400" />
              </div>
              <Input
                placeholder="Enter your full name"
                className="pl-10 bg-gray-800/50 border-gray-700 h-12 focus:border-blue-500 focus:ring-blue-500/20 transition-all duration-200"
                {...field}
                autoFocus
              />
            </div>
          </FormControl>
          <FormMessage className="text-sm text-red-400" />
          <p className="text-xs text-blue-100/50">This helps us personalize your experience</p>
        </FormItem>
      )}
    />
  );
}